const DEFAULT_COLLECTIONS_CONFIG = {
  readOnly: false,
  allowImportExport: true,
  allowReplace: true
};
export {
  DEFAULT_COLLECTIONS_CONFIG
};
//# sourceMappingURL=types.js.map
